import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class UnifiedProfileAbout extends BaseModel {
  static override constructorName = 'UnifiedProfileAboutModel'

  description: string | null = null
  'other_achievements': string | null = null

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UnifiedProfileAbout)
